import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';
import {Subject}                from 'rxjs';

import StoreName              from '../../../../State/Shared/Constants/StoreName';
import IPlayerStores          from '../../../../State/Shared/Interfaces/IPlayerStores';
import Playback               from '../../../../State/Stores/Playback/Playback';
import * as TestIds           from '../../../Shared/Constants/TestIds';
import UiEventType            from '../../../Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../Shared/Interfaces/IUiEventsStreamPayload';
import composeTokenList       from '../../Util/composeTokenList';
import renderTestId           from '../../Util/renderTestId';

import * as styles from './liveIndicator.css';

interface ILiveIndicatorProps extends IConnectProps<Playback, IPlayerStores> {
    areControlsIdle: boolean;
    uiEvents$: Subject<IUiEventsStreamPayload>;
}

@connect(StoreName.PLAYBACK)
class LiveIndicator extends React.Component<ILiveIndicatorProps> {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    private get liveLabelText(): string {
        return this.props.stores.config.value.text.liveLabel;
    }

    public shouldComponentUpdate(nextProps: ILiveIndicatorProps): boolean {
        return (
            nextProps.value.isAtLiveEdge !== this.props.value.isAtLiveEdge ||
            nextProps.areControlsIdle !== this.props.areControlsIdle
        );
    }

    public render(): JSX.Element {
        return this.props.value.isAtLiveEdge ?
            this.renderLiveIndicator() :
            this.renderReturnToLiveButton();
    }

    public renderLiveIndicator(): JSX.Element {
        const testId = composeTokenList([
            TestIds.PLAYER_LIVE_INDICATOR,
            [!this.props.areControlsIdle, TestIds.PLAYER_LIVE_INDICATOR_VISIBLE]
        ]);

        return (
            <div
                className={styles.liveIndicator}
                data-test-id={renderTestId(testId)}
            >{this.liveLabelText}</div>
        );
    }

    public renderReturnToLiveButton(): JSX.Element {
        const testId = composeTokenList([
            TestIds.PLAYER_BUTTON_RETURN_TO_LIVE,
            [!this.props.areControlsIdle, TestIds.PLAYER_BUTTON_RETURN_TO_LIVE_VISIBLE]
        ]);

        return (
            <button
                className={styles.returnToLiveButton}
                onClick={this.handleClick}
                data-test-id={renderTestId(testId)}
            >
                {this.liveLabelText}
                <div className={styles.returnToLiveArrow}></div>
            </button>
        );
    }

    private handleClick(): void {
        this.props.uiEvents$.next({
            type: UiEventType.SEEK_TO_LIVE_EDGE_TAP
        });
    }
}

export default LiveIndicator;